<template>
    <div>
    <div class="py-3"></div>
    
    <v-card
        class="mx-auto"
        max-width="90%"
    >
    <v-toolbar
        :color="'light-blue darken-3'"
        dark
    >    
    <v-toolbar-title><b>파트너 관리</b></v-toolbar-title>
        <v-spacer/>
        <v-btn
            color="cyan"
            small
            fab
            @click="OnClick_CreateItem"
        >
            <v-icon 
            color= "white"
            >mdi-plus</v-icon>
        </v-btn>
    </v-toolbar>
    <v-list>
        <v-data-table         
        :footer-props="{'items-per-page-options':[20, 50, -1]}"
        :headers="headers" 
        :items="partner_container"
        :loading="loadingData"
        >        
        <template v-slot:item="row">            
            <tr>
            <td>{{row.item.pid}}</td>
            <!-- <td>
                <img
                    :src="'https://content-filecenter.s3.ap-northeast-2.amazonaws.com/' + row.item.thumb_url" 
                    alt="Image"
                    style="width: 60px; height: 60px; order: 2px solid black; border-radius: 10px; margin-top: 5px;"
                />
            </td> -->
            <td>{{row.item.partner_name}}</td>
            <td>{{row.item.desc_text}}</td>
            <td>{{row.item.partner_key}}</td>
            <td>
                <v-btn width="120px"
                color="indigo"
                class='white--text'
                @click="OnClickEdit_Item(row.item)">편집하기</v-btn>
            </td>       
            </tr>
        </template>
        </v-data-table>
    </v-list>
    </v-card>

    <v-dialog
      v-model="dialog"
      max-width="600"
    >
      <v-card>
        <v-card-title class="text-h5 mb-3">
          <b> {{ dialog_title_text }}</b>
        </v-card-title>
        <v-card-text>
        <v-row style="margin-top: 30px; margin-bottom: 20px;">
            <v-col md="4" class="text-h6 mb-3">
            PartnerKey(Auto)
            </v-col>
            <v-col md="8" class="text-h6 mb-3" style="background-color: grey; height:52px; border-radius: 10px; color: white;">
                {{ dialog_partner_key }}  {{ is_edit_mode? "(변경불가)":""}} 
            </v-col>
        </v-row>
        <v-row>
            <v-text-field 
                label="파트너 네임 (스냅플레이)"
                v-model="dialog_partner_name" 
                outlined
                dense
            ></v-text-field>            
        </v-row>
        <v-row>
            <v-text-field 
                label="파트너 부가설명 (등록이슈 등 코멘트)"
                v-model="dialog_desc_text" 
                outlined
                dense
            ></v-text-field>            
        </v-row>
        <v-row>
            <v-text-field 
                label="플랫폼 콜백 (선택 - 협의 후 작성성)"
                v-model="dialog_callback_url" 
                outlined
                dense
            ></v-text-field>            
        </v-row>
        <!-- <v-row>
            <img
                    :src="'https://content-filecenter.s3.ap-northeast-2.amazonaws.com/' + dialog_thumb_path" 
                    alt="Image"
                    style="width:80px; height: 40px; order: 2px solid black; border-radius: 10px; margin-top: 5px;"
                />
                <v-file-input
                    height="10px"
                    hide-details
                    outlined
                    v-model="dialog_imageFile"
                    dense
                    style=" margin-bottom: 5px;"
                >
                    <template #label>변경</template>
                </v-file-input>

        </v-row> -->
        <!-- <v-row style="margin-top:40px;">
            <v-col md="3" class="text-h6 mb-3" style="height:50px; font-weight: 900;">
                퀴즈 카운트 
            </v-col>
            <v-col  md="3">
                <v-text-field 
                    label="퀴즈 갯수"
                    v-model="dialog_quiz_count" 
                    outlined
                    dense
                    style="width:120px;"
                ></v-text-field>                    
            </v-col>       
        
            <v-col  md="1"></v-col>
            <v-col md="3" class="text-h6 mb-3" style="height:50px; font-weight: 900;">
                활성화 설정
            </v-col>
            <v-col md="2" class="text-h6 mb-3" style="height:50px;">
                <v-switch
                    v-model="dialog_activate"
                    :true-value="1"
                    :false-value="0"
                    color="indigo"
                    label=""
                    hide-details
                    inset
                    style="margin: auto;"
                />           
            </v-col>       
        </v-row>  -->
    </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="green darken-1"
            text
            @click="CancelEdit"
          >
            취소
          </v-btn>

          <v-btn
            color="green darken-1"
            text
            @click="CreatePartnerInfo"
          >
            SAVE
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog 
        v-model="dialog_search"
        max-width="800">
        <v-card>
        <v-card-title class="text-h5 mb-3">
            광고 퀴즈번들 생성하기
        </v-card-title>
        </v-card>        
    </v-dialog>
    </div>

</template>

<script>
import { mapActions } from 'vuex';
import moment from 'moment'
import store from '../../store';
import config from '../../config/config';
const { s3_upload ,  FileUpload_Async} = require("../../util/fileutil");
import { format, parseISO } from 'date-fns'
export default {
    name: 'UserList',

    data: () => ({
        dialog : false,

        dialog_title_text :'',
        dialog_quiz_count:5,
        dialog_quizlist_info:[],
        
        checkedItems: Array(5).fill(false), // 체크박스 상태 관리
        dialog_checked_state :[],

        dialog_search:false,
    
        dialog_partner_key:"",
        dialog_partner_name:"",
        dialog_title:"",
        dialog_desc_text:"",
        dialog_thumb_path :'',
        dialog_callback_url:'',
        dialog_imageFile : null, 
        dialog_activate: false,


        is_edit_mode: false,


        loadingData:false,        
        create_date:'',
        quiz_title_text : '',

        
        headers: [            
            // { text: '썸네일', value: 'thumb' },
            { text: '고유번호', value: 'pid' },            
            { text: '회사이름', value: 'partner' },            
            { text: '코멘트', value: 'comment' },            
            { text: 'API_KEY', value: 'api_key' },            
            { text: '편집', value: 'button' },
        ],
        partner_container:[],
        

        selected_editing_item:{},
    }),

    mounted()
    {    
        this.LoadPartnerList();    
    },

    methods:{
        ...mapActions([
        'GET_PARTNER_LIST',
        'CREATE_PARTNER',
        'EDIT_PARTNER_INFO',
        ]),
        onCheckboxChange(isChecked , index, item) {
            item.need_ad = isChecked?1:0;
        },
        LoadPartnerList(){   
            this.GET_PARTNER_LIST({}).then((body_data)=>{
                this.loadingData = false; 
                // 파트너 이름 기준(한글/영문 포함)으로 정렬
                this.partner_container = body_data.result.sort((a, b) => {
                    return a.partner_name.localeCompare(b.partner_name, 'ko-KR');
                });
            })
            .catch((err) => {
                this.error = err;
                console.log(err);
            })
        },
        ShowDialog_CreateBundle()
        {
            this.imageFile = null;
            this.dialog = false;    
        },
        async CreatePartnerInfo()
        {
            if(this.dialog_partner_key == "" || 
            this.dialog_partner_name == "" || 
            this.dialog_desc_text == "" || 
            this.dialog_thumb_path == "" 
            )
            {
                alert("누락된 정보를 확인해주세요");
                return;
            }
            // dialog_partner_key:"",
            // dialog_partner_name:"",
            // dialog_title:"",
            // dialog_desc_text:"",
            // dialog_thumb_path :'',

            this.loadingData = true;
            this.dialog = false;    
            //create_quizlist_ad
            //let title = this.quiz_title_text;
            //let quiz_data = this this.dialog_quizlist_info;
            //var newFileName = "snapquiz/quiz_data_ad/"+this.Utill_CreateNewImageName('temp.json');            
            let thumb_url  = this.dialog_imageFile == null?this.dialog_thumb_path:"snapquiz/partner_banner/"+this.Utill_CreateNewImageName(this.dialog_imageFile.name);            
            
            if(this.dialog_imageFile != null)
            {
                await FileUpload_Async(this.dialog_imageFile, thumb_url);
            }
            let partner_key = this.dialog_partner_key;
            let partner_name = this.dialog_partner_name;
            let desc_text = this.dialog_desc_text;
            let callback_url = this.dialog_callback_url;

            if(!this.is_edit_mode)
            {
                console.log("Create Partner Info : " + partner_key);
                this.CREATE_PARTNER({partner_key, partner_name,  desc_text , callback_url , thumb_url }).then((body_data)=>{
                        this.loadingData = false;
                        this.LoadPartnerList();
                    })
                    .catch((err)=>{
                        this.error = err;
                        console.log(err);
                    });
                
            }
            else{
                let pid = this.selected_editing_item.pid;
                this.EDIT_PARTNER_INFO({pid , partner_key, partner_name, desc_text , callback_url , thumb_url }).then((body_data)=>{
                        this.loadingData = false;
                        this.LoadPartnerList();
                    })
                    .catch((err)=>{
                        this.error = err;
                        console.log(err);
                    });
            }
          
        },
      
        
        OnClickEdit_Item(item)
        {//아이템을 수정하려는 경우에 호출한다 
            // this.selected_editing_item = item;
            // this.dialog_title_text = "파트너 캠페인 정보 수정하기";
            // this.dialog_partner_key = item.partner_key;
            // this.dialog_partner_name = item.partner_name;
            // this.dialog_title = item.title;
            // this.dialog_desc_text = item.desc_text;
            // this.dialog_callback_url = item.callback_url;
            // this.dialog_thumb_path = item.thumb_url;
            // this.is_edit_mode = true;
            // this.dialog = true;
            // this.dialog_imageFile = null;
            //페이지를 이동합니다. 
            this.$router.push({
                path: '/partner_template',
                query: {
                    pid: item.pid,
                }
            });

        },

        OnClick_CreateItem()
        {
            this.dialog_title_text = "파트너 캠페인 정보 등록하기";
            this.dialog_partner_key = this.Utill_CreateNewPartnerKey(16);
            this.dialog_partner_name = "";
            this.dialog_title = "";
            this.dialog_desc_text = "";
            this.dialog_callback_url = "";
            this.dialog_thumb_path = "snapquiz/commons/images/commons/SnapQuiz_DefaultBanner.jpg";
            this.is_edit_mode = false;
            this.dialog = true;
            this.dialog_imageFile = null;
        },

        CancelEdit()
        {
            this.dialog = false;    
        },
        IsActiveState(_item)
        {
            return _item.active_yn=="Y"?true:false;
        },

        Utill_CreateNewImageName(originalFileName)
        { // 확장자 추출
            const fileExtension = originalFileName.substring(originalFileName.lastIndexOf('.')); // 예: ".png", ".jpg"
            // 랜덤 문자열 생성 (16자)
            const randomString = Math.random().toString(36).substring(2, 18); // 예: "5g8n4z6qx0ld3y7w"
            // 새 파일 이름 생성
            return randomString + fileExtension; // 예: "5g8n4z6qx0ld3y7w.png"
        },        
   
        Utill_CreateNewPartnerKey(hashLength) {
            const characters = 'abcdefghijklmnopqrstuvwxyz1234567890';
            let result = '';
            for (let i = 0; i < hashLength; i++) {
                result += characters.charAt(Math.floor(Math.random() * characters.length));
            }
            return "pub-"+result;
        },
      
      
        OnCopyItem(item)
        {
            console.log(JSON.stringify(item));
            if(item.commit_path != "")
            {   
                // navigator.clipboard.writeText(fullLink).then(() => {
                //     console.log("Text copied to clipboard:", fullLink);
                // }).catch(err => {
                //     console.error("Failed to copy text to clipboard:", err);
                // });
                let fullLink = "http:/quiz.snapplay.io/quizview_ad?pid=" + item.pid;
                console.log(fullLink);
                let textArea = document.createElement("textarea");
                textArea.value = fullLink;
                textArea.style.display = "fixed";
                textArea.style.left = "-999999px";
                textArea.style.top = "-999999px";
                document.body.appendChild(textArea);
                textArea.focus();
                textArea.select();
                return new Promise((res, rej) => {
                    document.execCommand('copy') ? res() : rej();
                    textArea.remove();
                    alert("Copied!")
                });
               // alert("복사완료 : " + fullLink);
            }
            
        },
        async OnSwitchChange(item, toggleValue)
        {

            let pid = item.pid;
            let partner_key = item.partner_key;
            let partner_name = item.partner_name;
            let title = item.title;
            let desc_text = item.desc_text;
            let callback_url = item.callback_url;
            let activate = toggleValue?"Y":"N";
            let thumb_url  = item.thumb_url;

            if(this.dialog_imageFile != null)
            {
                thumb_url  = "snapquiz/partner_banner/"+this.Utill_CreateNewImageName(this.dialog_imageFile.name);
                await FileUpload_Async(this.dialog_imageFile, thumb_url);
            }

            //EDIT_PARTNER_INFO({state}, {pid , partner_key, partner_name, title, desc_text , callback_url , thumb_url , activate})
            this.EDIT_PARTNER_INFO({pid , partner_key, partner_name, title, desc_text , callback_url , thumb_url , activate}).then((body_data)=>{
                this.LoadQuizBundleList();
            })
            .catch((err) => {
                this.error = err;
                console.log(err);
            })
        },
      
    },
    computed: {
        
    },
    components:{
    },
    watch :{
        
    }
};
</script>
<style>
.custom-list-item {
  margin: 0px !important;
  padding: 0px !important;  
}

.custom-list-item-content {
  padding: 0px !important;
  margin: 0px !important;
}

.custom-checkbox {
  margin: 0px !important;
  padding: 0px !important;
}

.large-checkbox {
  width: 20px;  /* 너비 */
  height: 20px; /* 높이 */
  margin: 10px;
}
</style>

